class SearchHighlighter {
    public init(): void {
        const urlSearchParamHighlight = 'highlight';
        const urlSearchParams = new URLSearchParams(window.location.search);

        if (!urlSearchParams.has(urlSearchParamHighlight)) {
            return;
        }

        const replaceRegExp = this.createHighlightRegExp(urlSearchParams.get(urlSearchParamHighlight));

        if (!replaceRegExp) {
            return;
        }

        const $body = $('body');
        const isAnyElementHighlighted =  this.handleHighlightingInHtmlElements($body, replaceRegExp);

        if (!isAnyElementHighlighted) {
            this.showNotFoundResult($body);
        }
    }


    private handleHighlightingInHtmlElements($element: any, replaceRegExp: any): boolean {
        let isThisOrChildrenChanged;
        let isChildrenChanged;
        let isElementTextChanged;


        if ($($element).is('script')) {
            return false;
        }

        const $children = $element.children();

        if ($element.is('div') && $element.hasClass('tabs')) {
            isChildrenChanged = this.handleHighlightingInTabs($children, replaceRegExp);
        } else {
            isChildrenChanged = this.handleHighlightingChildren($children, replaceRegExp);
            isElementTextChanged = this.highlightTextInElement($element, replaceRegExp);

            if (isChildrenChanged) {
                this.openElementIfAccordion($element);
            }
        }

        isThisOrChildrenChanged = isChildrenChanged || isElementTextChanged;

        return isThisOrChildrenChanged;
    }

    private highlightTextInElement($element: any, replaceRegExp: any): boolean {
        let isTextChanged;
        if (replaceRegExp.test($element.text())) {
            $element.contents().each((index: any, node: any) => {
                if (Node.TEXT_NODE === $(node).get(0).nodeType) {
                    const nodeValue = $(node).get(0).nodeValue;
                    replaceRegExp.lastIndex = 0;

                    if (replaceRegExp.test(nodeValue)) {
                        $(node).replaceWith(nodeValue.replace(replaceRegExp, '<mark class="on-page-mark">$1</mark>'));
                        isTextChanged = true;
                    }
                }
            });
        }

        return isTextChanged;
    }

    private handleHighlightingChildren($children:any , replaceRegExp: any): boolean {
        let isChildrenChanged = false;
        $children.each((index: any, me: any) => {
            isChildrenChanged = this.handleHighlightingInHtmlElements($(me), replaceRegExp) || isChildrenChanged;
        });

        return isChildrenChanged;
    }

    private handleHighlightingInTabs($children:any , replaceRegExp: any): boolean {
        let isChildrenChanged: boolean;
        let $navigationChild: any;
        let $firstContentChildChanged: any;
        let $tabContent: any;

        $children.each((index: any, me: any) => {
            if ($(me).is('ul') && $(me).hasClass('nav-tabs')) {
                $navigationChild = $(me);

                isChildrenChanged = this.handleHighlightingInHtmlElements($(me), replaceRegExp) || isChildrenChanged;
            } else if ($(me).is('div') && $(me).hasClass('tab-content')) {
                $tabContent = $(me);

                $(me).children().each((contentIndex, contentChild) => {
                    const isContentChildChanged = this.handleHighlightingInHtmlElements($(contentChild), replaceRegExp);
                    isChildrenChanged = isChildrenChanged || isContentChildChanged;
                    if (isContentChildChanged && !$firstContentChildChanged) {
                        $firstContentChildChanged = $(contentChild);
                    }
                });
            } else {
                isChildrenChanged = this.handleHighlightingInHtmlElements($(me), replaceRegExp) || isChildrenChanged;
            }
        });

        if ($firstContentChildChanged && $navigationChild && $tabContent) {
            const refId = $firstContentChildChanged.attr('id');
            $navigationChild.find(`a[href="#${refId}"]`).tab('show');
            $tabContent.find('div[class="tab-pane active"]').each((paneIndex: any, tabElement: any) => {
                $(tabElement).removeClass('active');
            });
            $firstContentChildChanged.addClass('active');
        }

        return isChildrenChanged;
    }

    private openElementIfAccordion($element: any): void {

        if ($element.is('div') && $element.hasClass('accordion-element') && !$element.hasClass('active')) {
            $element.addClass('active');
        }
    }


    private hasMinLength = (str: string) => str.length >= 3;

    private createHighlightRegExp(highlightParams: any): RegExp {
        const cleanedParams = highlightParams.replace(new RegExp('["«».*<>?^{}()$|\\[\\]\\\\+!%&/\']', 'g'), '');
        const splitAndFilteredParams = cleanedParams.split(' ').filter(this.hasMinLength);

        if (!splitAndFilteredParams || !Array.isArray(splitAndFilteredParams) || !splitAndFilteredParams.length) {
            return;
        }

        this.extendByMinusSymbolCases(splitAndFilteredParams);
        const searchWords = splitAndFilteredParams.join('|');

        return new RegExp(`(${searchWords})`, 'ig');
    }


    private extendByMinusSymbolCases(params: any): string[] {
        const minusSymbol = '-';
        params.forEach((str: any) => {
            if (str.includes(minusSymbol)) {
                params.push(...str.split(minusSymbol).filter(this.hasMinLength));
            }
        });

        return params;
    }

    private showNotFoundResult($element: JQuery<HTMLElement>): void {
        const $notFoundElement = $element.find('div.on-page-search-not-found.hidden');

        $notFoundElement.removeClass('hidden');
    }
}

export const searchHighlighter = new SearchHighlighter();
